import React from "react";
import { Box } from "@mui/material";
import { CompleteComment, Comment as SectionComment } from "components/CommentsSection";
import CommentsSection from "components/CommentsSection";
import { HistoryEntry } from "components/HistoriesSection";
import HistoriesSection from "components/HistoriesSection";
import { useSelectedOrganization } from "hooks";

interface MobileDetailCommentsProps {
  /** The active section to render — either the comments list or the history list. */
  value: "comments" | "history";
  comments: CompleteComment[];
  history: HistoryEntry[];
  canWrite: boolean;
  canEdit: boolean;
  onComment: (text: string) => Promise<void>;
  onEditComment: (id: number, text: string) => Promise<void>;
}

/**
 * Mobile "Commenti | Storia" tab body.
 * Renders either the CommentsSection or the HistoriesSection based on the parent tab state.
 * The toggle between the two lives in the MobileDetailTabBar.
 */
const MobileDetailComments: React.FC<MobileDetailCommentsProps> = ({
  value,
  comments,
  history,
  canWrite,
  canEdit,
  onComment,
  onEditComment,
}) => {
  const organization = useSelectedOrganization();
  return (
    <Box
      sx={{
        flex: 1,
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
        bgcolor: (t) => (t.palette.mode === "dark" ? "background.default" : "grey.50"),
      }}
    >
      <Box sx={{ flex: 1, overflowY: "auto", p: 1.5, "&::-webkit-scrollbar": { display: "none" }, scrollbarWidth: "none" }}>
        {value === "comments" ? (
          <CommentsSection
            canWrite={canWrite}
            canEdit={canEdit}
            onComment={async (c: SectionComment) => onComment(c.comment)}
            onEdit={async (id, text) => onEditComment(id, text)}
            comments={comments}
            mentionOrgId={organization?.id}
          />
        ) : (
          <HistoriesSection history={history} />
        )}
      </Box>
    </Box>
  );
};

export default MobileDetailComments;